/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.1
 */

/*
* -------------------------------------------
*                LOAD SURVEY
* -------------------------------------------
*/

import { createAction } from '../../../../../modules/app/createAction';
import {
    WIDGET_VOTING_LOAD_SURVEY,
    WIDGET_VOTING_LOAD_SURVEY_ERROR,
    WIDGET_VOTING_LOAD_SURVEY_SUCCESSFUL,
} from './constants/widgetVotingActionConstants';
import {
    IWidgetVotingLoadSurveyErrorPayload,
    IWidgetVotingLoadSurveySuccessfulPayload,
    TWidgetVotingLoadSurveyAction,
    TWidgetVotingLoadSurveyErrorAction,
    TWidgetVotingLoadSurveySuccessfulAction,
} from './types/widgetVotingActionTypes';

export const widgetVotingLoadSurvey = (): TWidgetVotingLoadSurveyAction =>
    createAction(WIDGET_VOTING_LOAD_SURVEY);

export const widgetVotingLoadSurveySuccessful =
    (payload: IWidgetVotingLoadSurveySuccessfulPayload): TWidgetVotingLoadSurveySuccessfulAction =>
        createAction(WIDGET_VOTING_LOAD_SURVEY_SUCCESSFUL, payload);

export const widgetVotingLoadSurveyError =
    (payload: IWidgetVotingLoadSurveyErrorPayload): TWidgetVotingLoadSurveyErrorAction =>
        createAction(WIDGET_VOTING_LOAD_SURVEY_ERROR, payload);


export type TWidgetVotingActions =
    TWidgetVotingLoadSurveyAction
    | TWidgetVotingLoadSurveyErrorAction
    | TWidgetVotingLoadSurveySuccessfulAction
